import {
  getTrendGraphDateFormat,
  groupBy,
} from "../../../utility/common-methods";
import { getLineGraphFormat, getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
const {
  PIE,
  BAR_HORIZONTAL,
  BAR_VERTICAL,
  BAR_STACKED,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
} = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatDataByTrend = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      entityKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const groupedDataByName = groupBy(data, entityKey) || {};
    const groupedDataByDate = groupBy(data, "publish_date") || {};
    const labels = Object.keys(groupedDataByDate); // Labels to be shown coloured(entities).
    const formattedLabel = labels.map((d) => getTrendGraphDateFormat(d));
    const listOfEntities = Object.keys(groupedDataByName);
    const correctedlabels = isLineGraph
      ? getLineGraphFormat(formattedLabel, true)
      : formattedLabel;
    if (graph_type === PIE) {
      const data =
        (listOfEntities &&
          listOfEntities.map((ent, index) => {
            let artCnt = 0;
            groupedDataByName[ent].forEach((el) => {
              artCnt += Number(el.cnt);
            });
            return artCnt;
          })) ||
        [];
      return {
        datasets: [
          {
            data,
            backgroundColor: getRandomUniqueColor(data.length),
            label: "Share of voice by trend",
          },
        ],
        labels: listOfEntities,
      };
    } else if (graph_type === WORD_CLOUD) {
      return data.map((el) => {
        return {
          text: el.entity,
          value: parseInt(el[countKey], 10),
        };
      });
    } else {
      const listData = listOfEntities || [];
      const graphColors = getRandomUniqueColor(listData.length);
      const datasets = listData.map((entry, index) => {
        let data = labels.map((elm) => {
          const tempArr = groupedDataByDate[elm];
          const currentElmArticleCount =
            (tempArr && tempArr.filter((e) => e[entityKey] === entry)[0]) || {};
          return currentElmArticleCount[countKey] || "0";
        });
        data = isLineGraph ? getLineGraphFormat(data) : data;
        return {
          label: entry,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          data,
          barThickness: "flex",
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        labels: correctedlabels,
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatDataByJournalistOld = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      sourceKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const groupedDataByName = groupBy(data, sourceKey) || {};
    const groupedDataByDate = groupBy(data, "publish_date") || {};
    const labels = Object.keys(groupedDataByDate); // Labels to be shown coloured(entities).
    const formattedLabel = labels.map((d) => getTrendGraphDateFormat(d));
    const listOfEntities = Object.keys(groupedDataByName);
    const correctedlabels = isLineGraph
      ? getLineGraphFormat(formattedLabel, true)
      : formattedLabel;
    if (graph_type === PIE) {
      const data =
        (listOfEntities &&
          listOfEntities.map((ent, index) => {
            let artCnt = 0;
            groupedDataByName[ent].forEach((el) => {
              artCnt += Number(el.cnt);
            });
            return artCnt;
          })) ||
        [];
      return {
        datasets: [
          {
            data,
            backgroundColor: getRandomUniqueColor(data.length),
            label: "Share of voice by trend",
          },
        ],
        labels: listOfEntities,
      };
    } else if (graph_type === WORD_CLOUD) {
      return data.map((el) => {
        return {
          text: el.entity,
          value: parseInt(el[countKey], 10),
        };
      });
    } else {
      const listData = listOfEntities || [];
      const graphColors = getRandomUniqueColor(listData.length);
      const datasets = listData.map((entry, index) => {
        let data = labels.map((elm) => {
          const tempArr = groupedDataByDate[elm];
          const currentElmArticleCount =
            (tempArr && tempArr.filter((e) => e[sourceKey] === entry)[0]) || {};
          return currentElmArticleCount[countKey] || "0";
        });
        data = isLineGraph ? getLineGraphFormat(data) : data;
        return {
          label: entry,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          data,
          barThickness: "flex",
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        labels: correctedlabels,
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatDataByJournalist = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      sourceKey,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;

    const journalistObj = {};
    for (const sourceList of Object.values(data)) {
      sourceList.forEach((sourceInfo) => {
        journalistObj[sourceInfo.source_id] = {
          source_id: sourceInfo.source_id,
          source_name: sourceInfo.source_name,
        };
      });
    }

    const journalistList = [];
    for (const obj of Object.values(journalistObj)) {
      journalistList.push(obj.source_name);
    }

    const formattedLabel = Object.keys(data).map((d) =>
      getTrendGraphDateFormat(d)
    );
    const correctedlabels = isLineGraph
      ? getLineGraphFormat(formattedLabel, true)
      : formattedLabel;

    const graphColors = getRandomUniqueColor(journalistList.length);

    const datasets = Object.values(journalistObj).map((obj, index) => {
      let data2 = Object.values(data).map((sourceList) => {
        const currentElmArticleCount =
          (sourceList &&
            sourceList.filter(
              (sourceInfo) => sourceInfo.source_id == obj.source_id
            )[0]) ||
          {};
        return currentElmArticleCount[countKey] || "0";
      });
      data2 = isLineGraph ? getLineGraphFormat(data2) : data2;
      return {
        label: obj.source_name,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        data: data2,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    return {
      labels: correctedlabels,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatDataByEdition = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      editionName,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const groupedDataByName = groupBy(data, editionName) || {};
    const groupedDataByDate = groupBy(data, "publish_date") || {};
    const labels = Object.keys(groupedDataByDate); // Labels to be shown coloured(entities).
    const formattedLabel = labels.map((d) => getTrendGraphDateFormat(d));
    const listOfEntities = Object.keys(groupedDataByName);
    const correctedlabels = isLineGraph
      ? getLineGraphFormat(formattedLabel, true)
      : formattedLabel;
    if (graph_type === PIE) {
      const data =
        (listOfEntities &&
          listOfEntities.map((ent, index) => {
            let artCnt = 0;
            groupedDataByName[ent].forEach((el) => {
              artCnt += Number(el.cnt);
            });
            return artCnt;
          })) ||
        [];
      return {
        datasets: [
          {
            data,
            backgroundColor: getRandomUniqueColor(data.length),
            label: "Share of voice by trend",
          },
        ],
        labels: listOfEntities,
      };
    } else if (graph_type === WORD_CLOUD) {
      return data.map((el) => {
        return {
          text: el.entity,
          value: parseInt(el[countKey], 10),
        };
      });
    } else {
      const listData = listOfEntities || [];
      const graphColors = getRandomUniqueColor(listData.length);
      const datasets = listData.map((entry, index) => {
        let data = labels.map((elm) => {
          const tempArr = groupedDataByDate[elm];
          const currentElmArticleCount =
            (tempArr && tempArr.filter((e) => e[editionName] === entry)[0]) ||
            {};
          return currentElmArticleCount[countKey] || "0";
        });
        data = isLineGraph ? getLineGraphFormat(data) : data;
        return {
          label: entry,
          backgroundColor:
            graph_type === AREA && typeof window.Color === "function"
              ? window.Color(graphColors[index]).alpha(0.5).rgbString()
              : graphColors[index],
          borderColor: graphColors[index],
          borderWidth: 1,
          data,
          barThickness: "flex",
          fill: graph_type === AREA ? "start" : false,
          lineTension: 0,
        };
      });
      return {
        labels: correctedlabels,
        datasets,
      };
    }
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};

export const formatDataByEditionEntity = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    d = d.length ? d[0] : {};
    let returnData = d[rType] && d[rType].returnData;
    const editionList = Object.keys(returnData);
    const entityList = [];
    for (const entityObj of Object.values(returnData).flat(1)) {
      if (entityList.indexOf(entityObj.entity) < 0) {
        entityList.push(entityObj.entity);
      }
    }
    const graphColors = getRandomUniqueColor(entityList.length);

    const datasets = entityList.map((entity, index) => {
      let data = editionList.map((edition) => {
        const entityWiseList = returnData[edition];
        const currentEditionCity =
          (entityWiseList &&
            entityWiseList.filter((e) => e.entity === entity)[0]) ||
          {};
        return currentEditionCity.cnt || "0";
      });
      data = isLineGraph ? getLineGraphFormat(data) : data;
      return {
        label: entity,
        backgroundColor:
          graph_type === AREA && typeof window.Color === "function"
            ? window.Color(graphColors[index]).alpha(0.5).rgbString()
            : graphColors[index],
        borderColor: graphColors[index],
        borderWidth: 1,
        data,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      };
    });
    return {
      labels: editionList,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
